import { createFileRoute } from "@tanstack/react-router";
import MentalHealthEducation from "@/pages/MentalHealthEducation";
export const Route = createFileRoute("/mental-health-education")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Mental Health Education | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Explore educational resources about depression, anxiety, insomnia, panic, trauma, TMS and helping someone you love in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content: "Mental Health Education | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Explore educational resources about depression, anxiety, insomnia, panic, trauma, TMS and helping someone you love in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/mental-health-resources",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/mental-health-resources",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <MentalHealthEducation />;
}
